import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController, ToastController} from '@ionic/angular';
import {RandomColors} from '../../definitions/random-colors';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import {FindProductPriceService} from '../../services/find-product-price.service';
import {DocumentModel} from '../../models/document.model';
import {PtserialBeansModel} from '../../models/ptserial-beans.model';
import {GeneralService} from '../../services/general.service';
import {SelectProductSerialPage} from '../select-product-serial/select-product-serial.page';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {TestConnectionService} from '../../services/test-connection.service';
import {GenerateDateFromTimestampService} from '../../services/generate-date-from-timestamp.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import { DocumentTypes } from 'src/app/definitions/document-types';

@Component({
    selector: 'app-product-select',
    templateUrl: './product-select.page.html',
    styleUrls: ['./product-select.page.scss'],
})

export class ProductSelectPage implements OnInit {

    @Input() detailLine: DetaillineDTOModel;
    @Input() document: DocumentModel;
    @Input() editItem: boolean;
    @Input() customerRepair: boolean;

    public level = 1;
    public deptList: any[];
    public groupList: any[];
    public productList: any[];
    public queryText = '';
    public prodQty = 1;
    public product: DetaillineDTOModel;
    public weeklyRate;
    public discount;
    public total;
    public comment: string;
    public filteredSerials: PtserialBeansModel[];
    public totalSerials: PtserialBeansModel[];
    public isDiscountable: boolean;
    public loading: any;
    lastUpdate: string;
    configuration: ConfigurationModel;


    constructor(private modalController: ModalController,
                private randomColors: RandomColors,
                private toastController: ToastController,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private findProductPriceService: FindProductPriceService,
                private generalService: GeneralService,
                private refreshDB: RefreshdatabaseService,
                private loadingController: LoadingController,
                private docTypes: DocumentTypes,
                private testConnection: TestConnectionService,
                private generateDateFromTimestamp: GenerateDateFromTimestampService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames) {
    }


    ngOnInit() {
        this.configuration = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        this.formatLastUpdateDate();
        this.deptList = this.stateManager.getCollection('dept');
        this.deptList.filter(dept => {
            if (!dept.descr) {
                dept.descr = '';
            }
        });

        if (this.detailLine) {
            this.product = this.detailLine;
        } else {
            this.product = new DetaillineDTOModel();
        }

        console.log(this.product);
        if (!this.document.detailLines) {
            this.document.detailLines = [];
        }

        if (this.detailLine) {
            this.product = this.detailLine;
        } else {
            this.product = new DetaillineDTOModel();
        }

        if (this.product.plu) {
            this.product = this.detailLine;
            this.prodQty = this.product.qty;
            this.setProduct(this.product);
        } else {
            this.level = 1;
        }

        if( this.customerRepair){
            this.showRepairProducts();
        }

    }

    pickColor(i) {
        if (i >= this.randomColors.colors.length) {
            i = i - this.randomColors.colors.length;
        }
        return this.randomColors.colors[i];
    }

    cancelModal() {
        this.queryText = '';
        if (this.editItem) {
            this.modalController.dismiss();
            return;
        }
        if (this.level > 1) {
            this.level--;
            if (this.level === 3 &&
                !(this.productList)) {
                this.level--;
                console.log('first if', this.level);
            }
            if (this.level === 2 &&
                !(this.groupList)) {
                this.level--;
            }
        } else {
            this.modalController.dismiss();
        }
    }

    refineToGroup(d: any) {
        this.level++;
        this.groupList = this.stateManager.getCollection('deptGroup');
        this.groupList = this.groupList.filter(group => {
            return group.dept === d.nsuk;
        });
        this.groupList.filter(group => {
            if (!group.descr) {
                group.descr = '';
            }
        });
    }

    refineToProd(g: any) {
        this.level++;
        this.productList = this.stateManager.getCollection('producttype');
        this.productList = this.productList.filter(prod => {
            return prod.group === g.nsuk;
        });
    }

    showAll() {
        this.level = 3;
        this.productList = this.stateManager.getCollection('producttype');
        console.log(this.productList);
    }

    showRepairProducts(){
        this.level = 2
        this.productList = this.stateManager.getCollection('producttype');
        this.deptList= this.deptList.filter(dept => {
            return dept.descr.toLowerCase() === "repairs";
        });
        
        if( this.deptList.length === 1){
            this.refineToGroup( this.deptList[0] );
            this.productList = this.stateManager.getCollection('producttype');
            this.productList = this.productList.filter(prod => {
                for( const group of this.groupList) {
                    if(  prod.group === group.nsuk ){
                        return true;
                    }
                }
                return false;
            });
        }

        this.productList.sort((a,b) => (a.description < b.description) ? -1 : 1 );
        //console.log(this.productList);
        
    }

    async setProduct(p: DetaillineDTOModel) {
        this.level = 4;
        this.product = p;
        if (this.document.documentType === this.docTypes.SERVICEJOB  || this.document.documentType === this.docTypes.CUSTOMERREPAIR ) {
            this.product.qty = 1;
            await this.modalController.dismiss(JSON.parse(JSON.stringify(p)));
            return;
        }

        if (!this.editItem) {
            await this.findProductPriceService.getPrice(this.product, this.document.customer).then(res => {
                console.log(res);
                this.weeklyRate = res.price;
                this.findEquipmentPriceService.isDiscountable(res.tender).then(result => {
                    console.log(result);
                    if (result === 1 && this.document.customer.name) {
                        this.discount = this.document.customer.saleDisc;
                    } else {
                        this.discount = 0;
                    }
                });
                // Due to a backend config the comment is considered as description
                this.comment = this.product.description;
            });
        } else {
            this.setEditValues();
        }
        this.calculatePrice();
        console.log(this.product);
    }

    async addProduct() {
        if (!(this.prodQty) || this.prodQty <= 0) {
            this.generalService.createToast('Invalid quantity');
            return;
        }

        if (this.document.documentType === this.docTypes.CONTRACT || this.document.documentType === this.docTypes.LOAN || this.document.documentType === this.docTypes.INVOICE ) {
            await this.populatePTSerials();
            if (this.totalSerials.length > 0) {
                if (this.filteredSerials.length === 0) {
                    alert('Product not available');
                    return;
                } else if (this.filteredSerials.length < this.prodQty) {
                    alert('Not enough products, please change quantity');
                    return;
                } else {
                    this.setProdDetails();
                    this.selectSerialModal();
                    return;
                }
            }
        }

        if (this.editItem) {
            this.setProdDetails();
            this.modalController.dismiss();
            this.product = new DetaillineDTOModel();
            return;
        }
        this.setProdDetails();
        const tempProd = JSON.parse(JSON.stringify(this.product));
        this.document.detailLines.push(tempProd);
        this.modalController.dismiss();
    }

    calculatePrice() {
        this.total = (this.weeklyRate - this.weeklyRate * this.discount / 100) * this.prodQty;
    }

    setDiscount() {
        this.product.discount = 0;
    }

    setProdDetails() {
        this.product.weeklyRate = this.weeklyRate;
        this.product.discount = this.discount;
        this.product.total = this.total;
        this.product.qty = this.prodQty;
        this.product.comment = this.comment;
        this.product.location = this.document.location;
    }

    setEditValues() {
        this.weeklyRate = this.product.weeklyRate;
        this.discount = this.product.discount;
        this.total = this.product.total;
        this.prodQty = this.product.qty;
        this.comment = this.product.comment;
    }

    populatePTSerials() {
        this.filteredSerials = this.stateManager.getCollection('ptserial');
        this.filteredSerials = this.filteredSerials.filter(serial => {
            return serial.productTypeId === this.product.id && serial.stat === 0;
        });
        this.totalSerials = this.stateManager.getCollection('ptserial');
        this.totalSerials = this.totalSerials.filter(serial => {
            return serial.productTypeId === this.product.id;
        });
    }

    async selectSerialModal() {
        const modal = await this.modalController.create({
            component: SelectProductSerialPage,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'product': this.product,
                'serials': this.filteredSerials
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.insertSerialIntoProduct(dataReturned.data);
                if (this.isProductAdded()) {
                    this.setProdDetails();
                    this.product = new DetaillineDTOModel();
                } else {
                    this.document.detailLines.push(this.product);
                }
                this.modalController.dismiss();
            }
        });

        return await modal.present();
    }

    insertSerialIntoProduct(serials: PtserialBeansModel[]) {
        const tempProduct = JSON.parse(JSON.stringify(this.product));
        tempProduct.ptSerialBeans = new Array<PtserialBeansModel>();
        for (const serial of serials) {
            tempProduct.ptSerialBeans.push(serial);
        }
        this.product = JSON.parse(JSON.stringify(tempProduct));
    }

    fetchProducts(event) {
        this.testConnection.pingServer().then(() => {
            this.refreshDB.refreshProductResource().then(() => {
                event.target.complete();
                this.formatLastUpdateDate();
                if (this.level === 3) {
                    this.showAll();
                } else {
                    this.deptList = this.stateManager.getCollection('dept');
                    this.groupList = this.stateManager.getCollection('deptGroup');
                    this.groupList.filter(group => {
                        if (!group.descr) {
                            group.descr = '';
                        }
                    });
                }
            }).catch(err => {
                event.target.complete();
            });
        }).catch(err => {
            event.target.complete();
            this.generalService.createToast('No Connection to the server');
        });

    }

    async editPTSerials() {
        await this.populatePTSerials();
        await this.selectSerialModal();
    }

    isProductAdded() {
        for (const line of this.document.detailLines) {
            if (line.plu) {
                if (line.plu === this.product.plu) {
                    return true;
                }
            }
        }
        return false;
    }

    formatLastUpdateDate() {
        this.lastUpdate = this.generateDateFromTimestamp.formatLastUpdateDate(this.configuration.productDateTime);
    }
}
